import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
import GoogleMaps from '../Map'
import styled from 'styled-components'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Tab from '@material-ui/core/Tab'
import Button from '../CustomButtons/Button'
import Tabs from '@material-ui/core/Tabs'

// core components
import GridContainer from '../Grid/GridContainer.jsx'
import GridItem from '../Grid/GridItem.jsx'

import navPillsStyle from '../../assets/jss/material-kit-pro-react/components/navPillsStyle.jsx'
import { navigateTo } from 'gatsby-link'

class LocationNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: props.active,
    }
  }
  handleChange = (event, active) => {
    this.setState({ active })
  }
  handleChangeIndex = index => {
    this.setState({ active: index })
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.setState({ active: this.props.active })
    }
  }

  render() {
    const {
      classes,
      tabs,
      direction,
      color,
      horizontal,
      alignCenter,
    } = this.props
    const flexContainerClasses = classNames({
      [classes.flexContainer]: true,
      [classes.horizontalDisplay]: horizontal !== undefined,
    })
    const tabButtons = (
      <Tabs
        classes={{
          root: classes.root,
          fixed: classes.fixed,
          flexContainer: flexContainerClasses,
          indicator: classes.displayNone,
        }}
        value={this.state.active}
        onChange={this.handleChange}
        centered={alignCenter}
      >
        {tabs.map((prop, key) => {
          var icon = {}
          if (prop.tabIcon !== undefined) {
            icon['icon'] = <prop.tabIcon className={classes.tabIcon} />
          }
          const pillsClasses = classNames({
            [classes.pills]: true,
            [classes.horizontalPills]: horizontal !== undefined,
            [classes.pillsWithIcons]: prop.tabIcon !== undefined,
          })
          return (
            <Tab
              onClick={() => this.props.onClick(prop)}
              label={prop.tabButton}
              key={key}
              {...icon}
              classes={{
                root: pillsClasses,
                labelContainer: classes.labelContainer,
                label: classes.label,
                selected: classes[color],
              }}
            />
          )
        })}
        {this.state.active === 0 && (
          <ContactButton
            href="//support.bitnational.com/hc/en-us/requests/new?ticket_form_id=360000199994"
            target="_blank"
            simple
            color="primary"
          >
            Contact for Placement
          </ContactButton>
        )}
      </Tabs>
    )
    const tabContent = (
      <div className={classes.contentWrapper}>
        {tabs.map((prop, key) => {
          if (key === this.state.active) {
            return (
              <div key={key}>
                <InfoContainer>{prop.infoContent}</InfoContainer>
                <GoogleMaps
                  defaultZoom={prop.mapContent.defaultZoom}
                  defaultCenter={prop.mapContent.mapCenter}
                  markerData={prop.mapContent.places}
                />
              </div>
            )
          }
          return null
        })}
      </div>
    )
    return horizontal !== undefined ? (
      <GridContainer>
        <GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
        <GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
      </GridContainer>
    ) : (
      <div>
        {tabButtons}
        {tabContent}
      </div>
    )
  }
}

const InfoContainer = styled.p`
  font-weight: 400;
  padding: 1rem;
`

const ContactButton = styled(Button)`
  &&& {
    margin-left: auto;

    @media screen and (max-width: 515px) {
      margin-left: 0;
      margin-top: 1rem;
      display: block;
    }
  }
`

LocationNav.defaultProps = {
  active: 0,
  color: 'primary',
}

LocationNav.propTypes = {
  classes: PropTypes.object.isRequired,
  // index of the default active pill
  active: PropTypes.number,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabButton: PropTypes.string,
      tabIcon: PropTypes.func,
      tabContent: PropTypes.node,
    })
  ).isRequired,
  color: PropTypes.oneOf([
    'primary',
    'warning',
    'danger',
    'success',
    'info',
    'rose',
  ]),
  direction: PropTypes.string,
  horizontal: PropTypes.shape({
    tabsGrid: PropTypes.object,
    contentGrid: PropTypes.object,
  }),
  alignCenter: PropTypes.bool,
}

export default withStyles(navPillsStyle)(LocationNav)



// WEBPACK FOOTER //
// ./src/components/NavPills/LocationNav.jsx